<template>
  <div class="mx-0 px-0">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="mx-auto container-xl mb-5">
      <div class="">
        <div class="title-area">
          <h1 class="page-title h2 mb-2">Group: <span :class="`${anon ? 'g-anon-lg' : ''}`">{{ group_name }}</span>
          </h1>
        </div>
      </div>
      <!-- Group information -->
      <div class="d-flex border-section justify-content-between">
        <div class="table-responsive table w-100 table-no-padding-first mb-5">
          <h3 class="mt-4">Group information</h3>
          <table class="table first-td-500 table-alternative">
            <tbody>
            <tr>
              <td>
                {{ 'Group name' }}
              </td>
              <td class="editable normal-input">
                <input
                  v-if="editable"
                  class="form-control"
                  :class="`${anon ? 'g-anon' : ''}`"
                  @change="savefield('group_name',group_name)"
                  v-model="group_name"
                />
                <span v-else :class="`${anon ? 'g-anon' : ''}`">
                  {{ group.group_name }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                Norm values
              </td>
              <td class="editable normal-input">
                <select
                  v-if="editable"
                  class="form-select col-12 col-lg-7 col-xl-6"
                  v-model="group_normvalues_id"
                  @change="savefield('group_normvalues_id',group_normvalues_id)"
                >
                  <option v-for="option in norm_values_options" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <span v-else :class="`${anon ? 'g-anon' : ''}`">
                  {{ (norm_values_options.find(n => String(n.value) === String(group.group_normvalues_id)) || {}).text || 'N/A' }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                Language
              </td>
              <td class="editable normal-input">
                <select
                  v-if="editable"
                  class="form-select col-12 col-lg-7 col-xl-6"
                  v-model="group_language_id"
                  @change="savefield('group_language_id',group_language_id)"
                >
                  <option v-for="option in language_options" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <span v-else :class="`${anon ? 'g-anon' : ''}`">
                  {{ (language_options.find(l => String(l.value) === String(group_language_id)) || {}).text || 'N/A' }}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
          <button :disabled="saving" class="btn btn-secondary btn-small mt-3" @click="toggleEditable">
              {{ editable ? 'Save' : 'Edit' }}
            </button>
        </div>
      </div>

      <!-- Group Members -->
      <div class="mb-4 pt-4 bt-1" style="border-top: 1px solid black !important;">
        <h3 class="m-0">Group Members</h3>
        <GroupMembers />
      </div>

      <!-- Group Surveys -->
      <div class="mb-4 pt-4 bt-1" style="border-top: 1px solid black !important;">
        <h3 class="m-0">Group surveys</h3>
        <GroupSurveys surveytype="ongoing" :groupid="group_id"/>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import GroupSurveys from './GroupSurveys.vue'
import GroupMembers from './GroupMembers.vue'

export default {
  name: 'GroupPage',
  components: {
    Navbar,
    Breadcrumb,
    GroupSurveys,
    GroupMembers
  },
  data () {
    return {
      saving: false,
      editable: false,
      loading: false,
      group_id: this.$store.state.currentgroup_id,
      group_name: null,
      group_name_valid: null,
      group_language_id: null,
      group_normvalues_id: null,
      group_normvalues_id_valid: null,
      labels: [],
      addinglabel: 0,
      addinglabeltext: '',
      surveycount_1: 0,
      surveycount_2: 0,
      surveycount_3: 0,
      surveycount_4: 0,
      surveycount_deleted: 0,
      groupMembersOpen: false,
      groupSurveysOpen: false
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    surveysselected: function () {
      return this.$store.state.selectedsurveys.length
    },
    group: {
      set (group) {
        this.$store.dispatch('group_set', { group })
      },
      get () {
        return this.$store.state.currentgroup
      }
    },
    language_options: {
      get () {
        const items = this.$store.state.languages
        const options = []
        options.push({ value: 0, text: 'Please select a language' })
        for (let i = 0; i < items.length; i++) {
          const option = {
            value: items[i].id,
            text: items[i].language_name
          }
          options.push(option)
        }
        return options
      },
      set () {
        return true
      }
    },
    norm_values_options: {
      get () {
        const items = this.$store.state.normvalues_countries
        const options = []
        options.push({ value: 0, text: 'Please select norm values' })
        for (let i = 0; i < items.length; i++) {
          const option = {
            value: items[i].country_id,
            text: items[i].country_name
          }
          options.push(option)
        }
        return options
      },
      set () {
        return true
      }
    }
  },
  created () {
    this.group_get()
    this.surveycounts_get()
    this.languages_get()
    this.normvalues_countries_get()
  },
  methods: {
    toggleEditable () {
      this.editable = !this.editable
      const rows = document.querySelectorAll('.table-alternative tr')
      rows.forEach(row => {
        if (this.editable) {
          row.classList.add('editable-row')
        } else {
          row.classList.remove('editable-row')
          this.saveform()
        }
      })
    },
    saveform () {
      if (!this.saving) {
        this.saving = true
        this.formchanged = false
        const data = {
          id: this.$store.state.currentgroup.id,
          group_name: this.group_name,
          group_language_id: this.group_language_id,
          group_normvalues_id: this.group_normvalues_id
        }
        this.$store.dispatch('group_save', { group: data })
          .then(() => {
            this.groupchanged = !this.groupchanged
            this.group_get()
            this.saving = false
          })
      }
    },
    async surveycounts_get () {
      this.loading = true
      const filter = {
        survey_deleted: {
          operator: '=',
          value: 0,
          realfield: 1
        },
        group_id: {
          operator: '=',
          value: this.group_id,
          realfield: 1
        }
      }
      this.surveycount_1 = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_status_id: { operator: '=', value: 1, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
      this.surveycount_2 = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_status_id: { operator: '=', value: 2, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
      this.surveycount_3 = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_status_id: { operator: '=', value: 3, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
      this.surveycount_4 = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_status_id: { operator: '=', value: 4, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
      this.surveycount_deleted = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_deleted: { operator: '=', value: 1, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
      this.loading = false
    },
    savefield (fieldname, value) {
      if (this.validateform()) {
        const data = {
          id: this.$store.state.currentgroup.id,
          [fieldname]: value
        }
        this.formchanged = false
        this.$store.dispatch('group_save', { group: data })
      }
    },
    validateform () {
      let result = true
      if (this.group_name === '') {
        this.group_name_valid = 'invalid'
        result = false
      } else {
        this.group_name_valid = 'valid'
      }
      if (Number(this.group_normvalues_id) === 0) {
        this.group_normvalues_id_valid = 'invalid'
        result = false
      }
      return result
    },
    group_get: function () {
      this.$store.dispatch('group_fetch', { id: this.$store.state.currentsurvey_id })
        .then(() => {
          this.group_name = this.$store.state.currentgroup.group_name
          this.group_language_id = this.$store.state.currentgroup.group_language_id
          this.group_normvalues_id = this.$store.state.currentgroup.group_normvalues_id
          this.loading = false
        })
    },
    group_save: function () {
      this.$store.dispatch('group_save', {
        group: this.group
      })
    },
    languages_get: function () {
      this.$store.dispatch('languages_fetch')
    },
    normvalues_countries_get: function () {
      this.$store.dispatch('normvalues_countries_fetch')
    },
    //= ======
    // LABELS
    //= ======
    labels_get () {
      this.$store.dispatch('grouplabels_fetch', { group_id: this.group_id })
        .then((resp) => {
          this.labels = resp.data
        })
    },
    saveaddlabel () {
      if (this.addinglabeltext !== '') {
        const savelabel = {
          group_id: this.addinglabel,
          label: this.addinglabeltext
        }
        this.$store.dispatch('grouplabel_add', { label: savelabel })
          .then(() => {
            this.labels_get()
          })
      }
      this.addinglabel = 0
      this.addinglabeltext = ''
    },
    addlabel (id) {
      this.addinglabel = id
      this.addinglabeltext = ''
      this.$nextTick(() => this.$refs.addinglabel.focus())
    },
    removelabel (grouplabel_id) {
      this.$store.dispatch('grouplabel_delete', { id: grouplabel_id })
        .then(() => {
          this.labels_get()
        })
    }
  }

}
</script>
<style scoped>
</style>
